export default "__VITE_ASSET__CnmqlIsc__"